import React, { FC } from 'react'

/**
 * min Ranting 从下标1开始
 */
// eslint-disable-next-line import/prefer-default-export
export const RadioButton: FC<{
  arr?: any[]
  labelKey?: string
  valueKey?: string
  value?: number
  disabled?: boolean
  className?: string
  StarClassName?: string
  onSelect?: (e: any) => void
}> = ({
  arr = [],
  labelKey = 'label',
  valueKey = 'value',
  value = 0,
  disabled,
  className = '',
  StarClassName = '',
  onSelect,
}) => {
  function onHandleSelect(index: number) {
    if (disabled) {
      return
    }
    onSelect?.(index)
  }
  return (
    <div className={`${className} cursor-none`}>
      {arr.map((i: any, idx) => (
        <div
          key={`radio-item${idx}`}
          className={`inline-block border rounded-full border-gray-100 bg-tag-grayf5 text-xs cursor-pointer ${
            i[valueKey] === value
              ? 'bg-tag-yellow-light border-tag-yellow-light text-white'
              : 'text-gray-400'
          } ${StarClassName}`}
          style={{ margin: '2px 3.5px' }}
          onClick={() => onHandleSelect(idx)}
        >
          <div
            className="flex justify-center items-center px-1 h-5.5"
            style={{ transform: 'scale(0.8333)', minWidth: '47px' }}
          >
            {i[labelKey]}
          </div>
        </div>
      ))}
    </div>
  )
}
